import {Content} from '@volkswagen-onehub/fa-content-service';
import React, {useEffect} from 'react';

import {Home} from './home';
import {useFeatureServices} from './use-feature-services';

export function App(props: {content: Content}): JSX.Element {
  const {'s2:history': historyService} = useFeatureServices();

  useEffect(() => {
    const unregister = historyService.history.listen(() => {
      console.log('history changes', historyService.history.location.pathname);
    });
    return unregister;
  });

  console.log('pathname', historyService.history.location.pathname);

  return <Home content={props.content} />;
}
